/* eslint-disable import/prefer-default-export */
import React from "react";
import { Box } from "@mui/material";

import Panel from "../../../../components/Panel";
import { StockSettings } from "./StockSettings";
import SettingsButton from "../../../../components/SettingsButton/SettingsButton";

interface Props {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  renderSettingButton?: boolean;
}

export const StockSettingsPanel = ({
  open,
  onOpenChange,
  renderSettingButton = true
}: Props): React.ReactNode => {
  const [internalOpen, setInternalOpen] = React.useState(false);

  const isControlled = typeof open === "boolean";
  const actualOpen = isControlled ? open : internalOpen;

  const setOpen = (value: boolean): void => {
    if (isControlled) {
      onOpenChange?.(value);
    } else {
      setInternalOpen(value);
    }
  };

  return (
    <>
      {renderSettingButton && <SettingsButton onClick={() => setOpen(!actualOpen)} />}

      {actualOpen && (
        <Panel onClose={() => setOpen(false)} title="IPD Settings">
          <Box>
            <StockSettings />
          </Box>
        </Panel>
      )}
    </>
  );
};
